import { HttpMethod, RequestOptions, useUserRequest } from "../common/lib/fetch";
import { UpsertKioskDto } from "./dtos/UpsertKioskDto";

const useAddKiosk = (siteId: string, options: RequestOptions) =>
  useUserRequest<UpsertKioskDto>({
    path: `/api/sites/${siteId}/kiosks`,
    method: HttpMethod.POST
  }, options);
   
export default useAddKiosk;